import * as React from 'react';

function SvgCreateLandlord(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16" {...props}>
      <path
        d="M12.122 8.522l.084.07 3.977 3.977a.6.6 0 01-.765.918l-.084-.07-.328-.328v2.21a.6.6 0 01-.502.593l-.098.008h-1.88a.6.6 0 01-.6-.6v-1.176h-.53V15.3a.6.6 0 01-.6.6H8.925a.6.6 0 01-.6-.6l-.001-1.978-.095.096a.6.6 0 01-.918-.766l.07-.083 3.977-3.977a.6.6 0 01.765-.07zM7.562.4a4.35 4.35 0 010 8.7A5.963 5.963 0 001.6 15.062a.6.6 0 01-1.2 0 7.165 7.165 0 014.699-6.727A4.35 4.35 0 017.562.4zm4.22 9.464l-2.259 2.258V14.7h.674v-1.176a.6.6 0 01.6-.6h1.73a.6.6 0 01.6.6V14.7h.68v-2.79-.019zM7.561 1.6a3.15 3.15 0 100 6.3 3.15 3.15 0 000-6.3z"
        fill="#38b2a6"
      />
    </svg>
  );
}

export default SvgCreateLandlord;
